//= Functions & Modules
// Others
import React from 'react';
import { PermissionsContext } from '../modules/permissions';

//= React components
// Others
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRobot, faCode, faCoins, faList, faFlask } from '@fortawesome/free-solid-svg-icons';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

//= Structures & Data
// Own
import { URLs } from '../data/URLs';

type BottomNavItemProps = {
    icon: IconDefinition;
    label: string;
    href: string;
};

function BottomNavItem({ icon, label, href }: BottomNavItemProps) {
    return (
        <NavLink
            to={href}
            className={({ isActive }) =>
                `flex flex-1 flex-col items-center justify-center gap-1 text-xs transition-colors ${isActive ? 'text-accent' : 'text-unselected1 hover:text-unselected2'
                }`
            }
        >
            {({ isActive }) => (
                <>
                    <div
                        className={`flex items-center justify-center w-10 h-6 rounded-full transition-colors ${isActive ? 'bg-accent/15' : ''
                            }`}
                    >
                        <FontAwesomeIcon icon={icon} className="text-base" />
                    </div>
                    <span className="font-medium">{label}</span>
                </>
            )}
        </NavLink>
    );
}

export default class BottomNav extends React.PureComponent {
    static contextType = PermissionsContext;
    context!: React.ContextType<typeof PermissionsContext>;

    render() {
        return (
            <nav
                className="flex items-stretch h-16 bg-[#13161a] md:hidden flex-shrink-0 z-40"
                style={{ borderTop: '1px solid rgba(255,255,255,0.07)' }}
            >
                <BottomNavItem icon={faRobot} label="Bots" href={URLs.BOTS} />
                <BottomNavItem icon={faCode} label="Maker" href={URLs.PROGRAM_MAKER} />
                <BottomNavItem icon={faCoins} label="Accounts" href={URLs.BINANCE_ACCOUNTS} />
                <BottomNavItem icon={faList} label="Programs" href={URLs.TRADING_PROGRAMS} />
                {this.context.includes('see_simulate') && (
                    <BottomNavItem icon={faFlask} label="Simulate" href={URLs.SIMULATE} />
                )}
            </nav>
        );
    }
}
